module.exports = __webpack_public_path__ + "static/media/cbs-tv-bbt-botm.30dd1dc5.png";